import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import { useButton, useI18n } from '~Hooks';
import useConfirm from '~Hooks/useConfirm';
import { BlueButton, Box, Button } from '~Styles';

const ConfirmModal: FC = () => {
  const { prompt, subtitle, isOpen, buttonTexts, onConfirm, onCancel } = useConfirm();
  const { i18n } = useI18n();

  const cancelButton = useButton({
    onClick: () => {
      if (onCancel) {
        onCancel();
      }
    },
  });

  const confirmButton = useButton({
    onClick: () => {
      if (onConfirm) {
        onConfirm(null);
      }
    },
  });

  if (!onConfirm || !onCancel) {
    return null;
  }

  return (
    <Modal isShowing={!!isOpen} backdropClose={false}>
      <ModalWrapper
        header={{ title: prompt || i18n('ConfirmModal.Default'), subtitle }}
        isHandy
        width="320px"
        margin="0 0 25% 0">
        <Box display="flex" flexDirection="row" fluid justifyContent="space-between" gap="small">
          <Button fluid {...cancelButton}>
            {buttonTexts?.left || i18n('General.Cancel')}
          </Button>
          <BlueButton fluid {...confirmButton}>
            {buttonTexts?.right || i18n('General.Confirm')}
          </BlueButton>
        </Box>
      </ModalWrapper>
    </Modal>
  );
};

export default ConfirmModal;
